import script from "./AdminServiceTableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminServiceTableActions.vue?vue&type=script&setup=true&lang=js"

import "./AdminServiceTableActions.vue?vue&type=style&index=0&id=42262862&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42262862"]])

export default __exports__